import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface RecordTimeModalProps {
  caseRef: string;
  username: string;
  timeTaskDesc: string;
  setTimeTaskDesc: (v: string) => void;
  timeManualUnits: string;
  setTimeManualUnits: (v: string) => void;
  handleStartTimer: () => void;
  onClose: () => void;
}

export default function RecordTimeModal({
  caseRef,
  username,
  timeTaskDesc,
  setTimeTaskDesc,
  timeManualUnits,
  setTimeManualUnits,
  handleStartTimer,
  onClose,
}: RecordTimeModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Record Time">
      <div className={s.modalForm}>
        <div className={s.formGroup}>
          <label>Case Reference</label>
          <input type="text" value={caseRef} readOnly className={s.readonlyInput} />
        </div>
        <div className={s.formGroup}>
          <label>User</label>
          <input type="text" value={username} readOnly className={s.readonlyInput} />
        </div>
        <div className={s.formGroup}>
          <label>Task Description</label>
          <input
            type="text"
            value={timeTaskDesc}
            onChange={(e) => setTimeTaskDesc(e.target.value)}
            placeholder="What are you working on?"
          />
        </div>
        <div className={s.formGroup}>
          <label>Manual Units (optional, 1 unit = 6 min)</label>
          <input
            type="number"
            min={0}
            value={timeManualUnits}
            onChange={(e) => setTimeManualUnits(e.target.value)}
            placeholder="Auto-calculated if left empty"
          />
        </div>
        <div className={s.modalActions}>
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button className={s.btnPrimary} onClick={handleStartTimer}>
            <FontAwesomeIcon icon={faPlay} /> Start Timer
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
